import { render, staticRenderFns } from "./studyCennter.vue?vue&type=template&id=40415e74"
import script from "./studyCennter.vue?vue&type=script&lang=js"
export * from "./studyCennter.vue?vue&type=script&lang=js"
import style0 from "./studyCennter.vue?vue&type=style&index=0&id=40415e74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports